var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentful = function SvgContentful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeLinejoin: "round",
    "data-testid": "geist-icon",
    style: {
      color: "currentcolor"
    },
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA00",
    d: "M4.804 11.157a4.47 4.47 0 0 1-1.292-3.17c0-1.185.47-2.33 1.321-3.162a1.763 1.763 0 0 0 .147-2.486 1.763 1.763 0 0 0-2.486-.147c-.049.05-.097.088-.137.137-3.131 3.113-3.141 8.172-.039 11.304a1.763 1.763 0 0 0 2.486.137 1.763 1.763 0 0 0 .137-2.486c-.049-.039-.088-.088-.137-.127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#67B3FF",
    d: "M4.833 4.825a4.48 4.48 0 0 1 6.332.02A1.755 1.755 0 0 0 13.651 5c.724-.646.803-1.761.157-2.486-.05-.049-.098-.107-.147-.146a7.974 7.974 0 0 0-11.304-.04 1.755 1.755 0 0 0-.156 2.486 1.755 1.755 0 0 0 2.486.157q.072-.074.146-.147"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB5A68",
    d: "M11.146 11.177a4.48 4.48 0 0 1-3.171 1.301c-1.184 0-2.33-.47-3.161-1.321a1.763 1.763 0 0 0-2.486-.147 1.764 1.764 0 0 0-.147 2.486c.049.049.088.098.137.137 3.102 3.132 8.152 3.161 11.284.059l.02-.02c.695-.685.695-1.8.01-2.495a1.77 1.77 0 0 0-2.486 0"
  })));
};
export default SvgContentful;